import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-office-contract',
  templateUrl: './office-contract.component.html',
  styleUrls: ['./office-contract.component.css']
})
export class OfficeContractComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
  }

  continuar(event : any){
    //alert(event.message);
    this.router.navigate(['/office/home']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/office-contract/office-contract.component.ts